import { render, staticRenderFns } from "./CommonStatTableOne.vue?vue&type=template&id=06530222&scoped=true"
import script from "./CommonStatTableOne.vue?vue&type=script&lang=js"
export * from "./CommonStatTableOne.vue?vue&type=script&lang=js"
import style0 from "./CommonStatTableOne.vue?vue&type=style&index=0&id=06530222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06530222",
  null
  
)

export default component.exports